import type { PageType, PageName } from '@shared/types//utils';

import PageNames from '@shared/constants/page-names';
import PageTypes from '@shared/constants/page-types';

const DEFAULT_PAGE_NAME_MAP: Record<PageType, PageName> = {
  [PageTypes.HOME]: PageNames.HOME,
  [PageTypes.SEARCH]: PageNames.SEARCH,
  [PageTypes.DETAILS]: PageNames.DETAILS,
  [PageTypes.DEALS]: PageNames.DEALS,
};

const SEO_OVERRIDES: Partial<Record<PageType, PageName>> = {
  [PageTypes.DETAILS]: PageNames.SEO_DETAILS,
};

export const getPageName = (
  pageType: PageType,
  isSeoTraffic: boolean,
): PageName => {
  if (isSeoTraffic && SEO_OVERRIDES[pageType]) {
    return SEO_OVERRIDES[pageType];
  }
  return DEFAULT_PAGE_NAME_MAP[pageType];
};
